<div class="tab-wrapper" [ngStyle]="{ width: width, 'padding-left': paddingLeft }">
  <div
    #tab
    class="ag-tab"
    *ngFor="let tab of tabList; let i = index"
    [ngClass]="{ active: selectedTab === tab.title, disabled: tab.isDisabled }"
    (click)="selectTab(tab)"
    [ngStyle]="{ 'padding-left': i === 0 ? '0px' : '16px' }">
    <img
      *ngIf="tab.image"
      [src]="tab.image"
      [ngStyle]="{
        '--inactive-filter': imageFilters.mediumgrey,
        '--active-filter': imageFilter
      }" />
    <h4 [ngClass]="selectedTab === tab.title ? 'h4-semibold' : 'h4-medium'" [ngStyle]="{ '--active-color': activeColor, color: selectedTab === tab.title ? activeColor : '#a6a6a6' }">{{ tab.title }}</h4>
    <ag-notification-badge *ngIf="tab.notification > 0" [notification]="tab.notification"></ag-notification-badge>
  </div>
  <div
    class="active-indicator"
    [style.transform]="'translateX(' + indicatorLeft + 'px)'"
    [style.width.px]="indicatorWidth"
    [style.background-color]="activeColor"></div>
</div>
